import { render, staticRenderFns } from "./UpdateService.vue?vue&type=template&id=ab10aa44&"
import script from "./UpdateService.vue?vue&type=script&lang=js&"
export * from "./UpdateService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports